<template>
    <div class="menu-modal-container">
        <div class="menu-modal-content menu-modal-content-background-danger">
            <div class="menu-modal-content-header">
                UMA
            </div>
            <div class="menu-modal-content-body">
                <div class="menu-modal-content-title">
                    <div class="menu-modal-icon menu-modal-icon-danger">
                        <span class="mdi mdi-exclamation-thick"></span>
                    </div>
                    <div class="menu-modal-content-title-text">
                        <p>¿Está seguro de que desea pausar la orden con cero cajas?</p>
                    </div>
                </div>
                <div class="menu-modal-main-section">
                    <div class="menu-modal-secondary-text-container">
                        <p class="menu-modal-secondary-text">
                            La orden tiene producción realizada. 
                            <br>
                            Si continua, se pausará la orden y se eliminará la producción realizada.
                        </p>
                    </div>
                </div>
                <div class="menu-btn-modal-container">
                    <button class="menu-modal-btn menu-modal-confirm-danger-btn" @click="pause">Sí, pausar orden</button>
                    <button class="menu-modal-btn menu-modal-cancel-danger-btn" @click="closeConfirm">Cancelar</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "PauseOrderReferenceButtonActionModalConfirm",
    props: {
        closeConfirm: {
            type: Function,
            required: true,
        },
        orderReference: {
            type: Object,
            required: true,
        },
        pauseOrderReference: {
            type: Function,
            required: true,
        },
    },
    methods: {
        pause() {
            this.closeConfirm();
            this.pauseOrderReference();
        },
    },
};
</script>